/**
* cookie工具
*/

export default {
  set: function setItem(key, value, domain, second, path) {
    var cookieParam = domain ? "domain=" + domain + ';': '';
    var expires = new Date();
    expires.setTime(expires.getTime() + second * 1000);
    var expiresParam = second ? "expires=" + expires.toUTCString() + ';': '';
    var pathParam = path ? "path=" + path + ';': '';
    const cookie = key + "=" + encodeURIComponent(value) + "; " + cookieParam + expiresParam + pathParam;
    document.cookie = cookie;
  },
  get: function getItem(key) {
    var reg = new RegExp(key + "=([^;]*)");
    var matchRes = document.cookie.match(reg);
    if (matchRes) {
      return decodeURIComponent(matchRes[1]);
    }
    return null;
  },
  remove: function removeItem(key, cookieDomain) {
    var reg = new RegExp(key + "=([^;]*)");
    var matchRes = document.cookie.match(reg);
    var domain = cookieDomain ? "domain=" + cookieDomain +  ";" : '';
    if (matchRes) {
      document.cookie = matchRes[0] + ';path=/;' + domain + 'Max-age=-1;';
    }
  }
};
